import * as React from "react";
import { useState } from "react";
import { store } from "react-notifications-component";
import "react-notifications-component/dist/theme.css";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import { CardLink, CardText, Input, Spinner } from "reactstrap";
import { Dispatch } from "redux";
import { testimonialAction } from "../../actions/testimonialAction";
import { DABBackToList, LoadingSpinnerModal } from "../../components/dab";
import { getLoggedUserId } from "../../services/selectors/Accounts";
import { showAlertWithBacktrack } from "../common/functions";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import HlsPlayer from "./hlsPlayer";

interface TestimonialProps {
	dispatch: Dispatch<any>;
	testimonialData: any;
	callback: any;
	id: number;
}

const TestimonialDetail: React.SFC<TestimonialProps> = ({
	dispatch,
	testimonialData,
	callback,
	id,
}) => {
	const history = useHistory();

	const [showModal, setShowModal] = useState(false);
	const [isDetailLoaded, setDetailLoaded] = useState(false);
	const [isErrorOnPage, setIsErrorOnPage] = useState(false);
	const [isPreviewPage, setIsPreviewPage] = useState(false);
	const [isVideoLoading, setIsVideoLoading] = useState(true);

	const handleStatusChange = async (status: string) => {
		try {
			const data = {
				adminUserId: parseInt(getLoggedUserId()),
				messageId: id,
				isApproved:
					status === "approved" ? true : status === "rejected" ? false : "",
			};
			setShowModal(true);
			await dispatch(testimonialAction.updateTestimonialStatus(data));
		} catch (error) {
			console.error("Failed to update testimonial:", error);
		}
	};

	const handleLoadShowModal = (value: boolean) => {
		setShowModal(value);
	};

	const handleBackClick = (event) => {
		window.location.href = "/testimonial";
	};

	React.useEffect(() => {
		if (id >= 0) {
			dispatch(testimonialAction.testimonialGetDetail(id));
		}
	}, []);

	React.useEffect(() => {
		if (testimonialData?.isUpdateStatus) {
			dispatch(testimonialAction.testimonialGetDetail(id));
			var alertMessage = window.localStorage.getItem("alertMessage");
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				testimonialData.isUpdateStatus = false;
				window.localStorage.setItem("alertMessage", "");
			}
		}
	}, [testimonialData?.isUpdateStatus]);

	if (testimonialData) {
		if (
			testimonialData.isError &&
			!isErrorOnPage &&
			!testimonialData.isSuccess
		) {
			if (showModal) {
				setShowModal(false);
			}
			if (testimonialData.status === "Unauthorized") {
				history.push("/401");
			} else {
				showAlertWithBacktrack(testimonialData.status, true, history);
			}
			testimonialData.isError = false;
			setIsErrorOnPage(true);
		}

		if (testimonialData.isUpdateStatus) {
			window.localStorage.setItem("alertMessage", testimonialData.status);
		}

		if (testimonialData.isSuccess && !testimonialData.isError) {
			if (
				!isDetailLoaded &&
				testimonialData.testimonialInput &&
				testimonialData.testimonialInput !== null
			) {
				// callback(testimonialData.testimonialInput.title);
				setDetailLoaded(true);
			}
		}
		if (showModal) {
			setShowModal(false);
		}
	}

	const videoEnhanceStatus = (status) => {
		switch (status) {
			case 0:
				return "Enhancement in Progress";
			case 1:
				return "Enhanced Video";
			case 2:
				return "Original Video";
			default:
				return "Original Video";
		}
	};

	return (
		<div className="testimonial-detail">
			{showModal && (
				<LoadingSpinnerModal
					isShowModal={showModal}
					modalChange={handleLoadShowModal}
				/>
			)}
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={handleBackClick}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to List
					</CardLink>
				</div>
				{testimonialData?.testimonialInput && (
					<>
						<CardText className="d-flex justify-content-between align-items-center">
							<span>
								<strong>Testimonial ID: </strong> #
								{testimonialData?.testimonialInput?.messageId}
							</span>
							<span className="video-status">
								<strong>Video status: </strong>
								{testimonialData?.testimonialInput?.messageAttachments?.[0]
									?.videoEnhanceStatus === 0 ? (
									<span>-</span>
								) : (
									<Input
										type="select"
										bsSize="sm"
										value={
											testimonialData?.testimonialInput?.isApproved === true
												? "approved"
												: testimonialData?.testimonialInput?.isApproved ===
												  false
												? "rejected"
												: "pending"
										}
										onChange={(e) => handleStatusChange(e.target.value)}
										style={{
											fontWeight: "bold",
											fontSize: "13px",
										}}
									>
										{testimonialData?.testimonialInput?.isApproved === null && (
											<option value="pending">Pending</option>
										)}
										<option value="approved">Approved</option>
										<option value="rejected">Rejected</option>
									</Input>
								)}
							</span>
							{testimonialData?.testimonialInput?.createdByUser?.firstName && (
								<span className="testimonial-name">
									<strong>Author by:</strong>{" "}
									{testimonialData?.testimonialInput?.createdByUser?.firstName +
										" " +
										testimonialData.testimonialInput?.createdByUser?.lastName}
								</span>
							)}
							<span>
								<strong>Video Status: </strong>
								{videoEnhanceStatus(
									testimonialData?.testimonialInput?.messageAttachments?.[0]
										?.videoEnhanceStatus
								)}
							</span>
							<span>
								<strong>Created Date:</strong>
								{new Date(
									testimonialData?.testimonialInput?.createdAtUtc
								).toLocaleDateString()}
							</span>
						</CardText>
						{testimonialData?.testimonialInput?.messageAttachments?.[0]
							?.videoEnhanceStatus === 0 ? (
							<h5 className="enhance-msg vid-enhance-msg">
								<strong className="d-flex justify-content-center">
									Video Enhancement is in progress, please check back later.
								</strong>
							</h5>
						) : (
							<>
								{testimonialData?.testimonialInput?.messageAttachments?.[0]
									?.resourceUrl && (
									<div
										className="mb-3"
										style={{
											maxWidth: "100%",
											maxHeight: "90vh",
											display: "flex",
											justifyContent: "center",
											alignItems: "center",
											overflow: "hidden",
										}}
									>
										<HlsPlayer
											src={
												testimonialData?.testimonialInput
													?.messageAttachments?.[0]?.resourceUrl
											}
										/>
									</div>
								)}
							</>
						)}
					</>
				)}
			</div>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { testimonialData } = state;
	return {
		testimonialData,
	};
};

export default connect(mapStateToProps)(TestimonialDetail);
